var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagebox"},[_c('PHeader'),_c('div',{staticClass:"noticediv"},[_c('div',{staticClass:"noticecon"},[_c('div',{staticClass:"txt",domProps:{"innerHTML":_vm._s(_vm.ContentData.RichTextContent)}})])]),_c('PFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }